import React, { useEffect, useState, useCallback } from "react";
import { useAxios } from "../../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../../environment/BackendService";
import { fetchDropdownValues } from "../../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../common_nextgen/utils/Constants";
import { useToast } from "../../../../common_nextgen/hooks/ToastContext";
import { downloadCSV } from "../../../../common_nextgen/utils/UtilFunctions";

const useMultiSourceCodeList = (
  onSelect,
  hideModal,
  initialSelectParams,
  initialLookupType
) => {
  const [data, setData] = useState([]);
  const { axios_helper_no_header } = useAxios();
  const [paramsData, setParamsData] = useState({
    searchCriteria: "",
    description: "",
  });
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const {
    ADD_MULTI_SOURCE_CODE_LIST,
    DISPLAY_MULTI_SOURCE_CODE_LIST,
    CODES_MULTI_SOURCE_CODE_LIST,
  } = ROUTE_PATHS;

  const screen_title = "Multi-Source Code List";
  const screenNumber = "RCMSL005";

  const formFields = [
    {
      fieldLabel: "MSL Multi-Source List",
      name: "searchCriteria",
      label: "List",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "MSL Multi-Source Lst Desc",
      name: "description",
      label: "Description",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 25,
    },
  ];

  const dropdownOptions = [];

  const handleBack = useCallback(() => {
    if (lookupType === "external") {
      const message = {
        type: "hideModal",
      };
      window.parent.postMessage(message, "*");
    } else {
      hideModal();
    }
  }, [hideModal, lookupType]);

  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        handleBack();
      },
      button_key: "F12",
    },
  ];

  const handleMessage = (event) => {
    const { type, data } = event.data;
    console.log("iframe load", type, data);
    if (type === "initData") {
      const { selectMode, data: paramData } = data;
      console.log("external data", paramData, selectMode);
      setLookupType("external");
      setSelectParams(paramData.params);
      setParamsData(paramData.paramsData);
      // setSelectedPatient([...paramData.selectedSchedule]);
      //setSelectMode(selectMode);
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  const ctaButtons = [
    // {
    //   button_label: "Back",
    //   button_handeler: () => {
    //     navigateToPage(BACK);
    //   },
    //   button_key: "F12",
    // },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const menuOptions = [
    {
      label: "Select",
      icon: <span className="material-icons">add</span>,
      command: () => {
        const paramDataMap = new Map();
        selectParams.forEach((key) => {
        if (rowData.hasOwnProperty(key["target"])) {
          paramDataMap.set(key["source"], rowData[key["target"]]);
          }
        });
        const paramData = Object.fromEntries(paramDataMap);
        if (lookupType !== "external") {
          onSelect(paramData);
        } else {
          const message = {
            type: "responseData",
            data: paramData,
          };
          window.parent.postMessage(message, "*");
        }
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        const message = {
          message: "navigate-to-presto",
          programCode: "RCMSL003I",
          parameters: {
            mslMultiSourceList: rowData["list"],
            workInitialProgramMode: "DSP",
          },
        };
        console.log(message, "message");
        window.top?.postMessage(message, "*");
      },
    },
    {
      label: "Codes",
      icon: <span className="material-icons">code</span>,
      command: () => {
        const message = {
          message: "navigate-to-presto",
          programCode: "RCML1001I",
          parameters: {
            mslMultiSourceList: rowData["list"],
            mslMultiSourceLstDesc: rowData["description"],
          },
        };
        console.log(message, "message");
        window.top?.postMessage(message, "*");
      },
    },
  ];

  const columnDef = [
    {
      header: "List",
      field: "list",
    },
    {
      header: "Description",
      field: "description",
    },
  ];

  const parmKey = "list";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/rcmslp`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData();
  }, []);

  useEffect(() => {
    fetchData();
  }, [paramsData, rows, currentPage, selectedOption]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/rcmslp/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    setSelectedOption,
    leftButtons,
  };
};

export default useMultiSourceCodeList;
